export interface CountryState {
  id: number;
  id_country: number;
  code: string;
  name: string;
}

// eslint-disable-next-line import/no-anonymous-default-export
const states = [
  {
    id: 1,
    id_country: 184,
    code: 'AL',
    name: 'Alabama',
  },
  {
    id: 2,
    id_country: 184,
    code: 'AK',
    name: 'Alaska',
  },
  {
    id: 3,
    id_country: 184,
    code: 'AZ',
    name: 'Arizona',
  },
  {
    id: 4,
    id_country: 184,
    code: 'AR',
    name: 'Arkansas',
  },
  {
    id: 5,
    id_country: 184,
    code: 'CA',
    name: 'California',
  },
  {
    id: 6,
    id_country: 184,
    code: 'CO',
    name: 'Colorado',
  },
  {
    id: 7,
    id_country: 184,
    code: 'CT',
    name: 'Connecticut',
  },
  {
    id: 8,
    id_country: 184,
    code: 'DE',
    name: 'Delaware',
  },
  {
    id: 9,
    id_country: 184,
    code: 'FL',
    name: 'Florida',
  },
  {
    id: 10,
    id_country: 184,
    code: 'GA',
    name: 'Georgia',
  },
  {
    id: 11,
    id_country: 184,
    code: 'HI',
    name: 'Hawaii',
  },
  {
    id: 12,
    id_country: 184,
    code: 'ID',
    name: 'Idaho',
  },
  {
    id: 13,
    id_country: 184,
    code: 'IL',
    name: 'Illinois',
  },
  {
    id: 14,
    id_country: 184,
    code: 'IN',
    name: 'Indiana',
  },
  {
    id: 15,
    id_country: 184,
    code: 'IA',
    name: 'Iowa',
  },
  {
    id: 16,
    id_country: 184,
    code: 'KS',
    name: 'Kansas',
  },
  {
    id: 17,
    id_country: 184,
    code: 'KY',
    name: 'Kentucky',
  },
  {
    id: 18,
    id_country: 184,
    code: 'LA',
    name: 'Louisiana',
  },
  {
    id: 19,
    id_country: 184,
    code: 'ME',
    name: 'Maine',
  },
  {
    id: 20,
    id_country: 184,
    code: 'MD',
    name: 'Maryland',
  },
  {
    id: 21,
    id_country: 184,
    code: 'MA',
    name: 'Massachusetts',
  },
  {
    id: 22,
    id_country: 184,
    code: 'MI',
    name: 'Michigan',
  },
  {
    id: 23,
    id_country: 184,
    code: 'MN',
    name: 'Minnesota',
  },
  {
    id: 24,
    id_country: 184,
    code: 'MS',
    name: 'Mississippi',
  },
  {
    id: 25,
    id_country: 184,
    code: 'MO',
    name: 'Missouri',
  },
  {
    id: 26,
    id_country: 184,
    code: 'MT',
    name: 'Montana',
  },
  {
    id: 27,
    id_country: 184,
    code: 'NE',
    name: 'Nebraska',
  },
  {
    id: 28,
    id_country: 184,
    code: 'NV',
    name: 'Nevada',
  },
  {
    id: 29,
    id_country: 184,
    code: 'NH',
    name: 'New Hampshire',
  },
  {
    id: 30,
    id_country: 184,
    code: 'NJ',
    name: 'New Jersey',
  },
  {
    id: 31,
    id_country: 184,
    code: 'NM',
    name: 'New Mexico',
  },
  {
    id: 32,
    id_country: 184,
    code: 'NY',
    name: 'New York',
  },
  {
    id: 33,
    id_country: 184,
    code: 'NC',
    name: 'North Carolina',
  },
  {
    id: 34,
    id_country: 184,
    code: 'ND',
    name: 'North Dakota',
  },
  {
    id: 35,
    id_country: 184,
    code: 'OH',
    name: 'Ohio',
  },
  {
    id: 36,
    id_country: 184,
    code: 'OK',
    name: 'Oklahoma',
  },
  {
    id: 37,
    id_country: 184,
    code: 'OR',
    name: 'Oregon',
  },
  {
    id: 38,
    id_country: 184,
    code: 'PA',
    name: 'Pennsylvania',
  },
  {
    id: 39,
    id_country: 184,
    code: 'RI',
    name: 'Rhode Island',
  },
  {
    id: 40,
    id_country: 184,
    code: 'SC',
    name: 'South Carolina',
  },
  {
    id: 41,
    id_country: 184,
    code: 'SD',
    name: 'South Dakota',
  },
  {
    id: 42,
    id_country: 184,
    code: 'TN',
    name: 'Tennessee',
  },
  {
    id: 43,
    id_country: 184,
    code: 'TX',
    name: 'Texas',
  },
  {
    id: 44,
    id_country: 184,
    code: 'UT',
    name: 'Utah',
  },
  {
    id: 45,
    id_country: 184,
    code: 'VT',
    name: 'Vermont',
  },
  {
    id: 46,
    id_country: 184,
    code: 'VA',
    name: 'Virginia',
  },
  {
    id: 47,
    id_country: 184,
    code: 'WA',
    name: 'Washington',
  },
  {
    id: 48,
    id_country: 184,
    code: 'WV',
    name: 'West Virginia',
  },
  {
    id: 49,
    id_country: 184,
    code: 'WI',
    name: 'Wisconsin',
  },
  {
    id: 50,
    id_country: 184,
    code: 'WY',
    name: 'Wyoming',
  },
  {
    id: 1,
    id_country: 184,
    code: 'AL',
    name: 'Alabama',
  },
  {
    id: 2,
    id_country: 184,
    code: 'AK',
    name: 'Alaska',
  },
  {
    id: 3,
    id_country: 184,
    code: 'AZ',
    name: 'Arizona',
  },
  {
    id: 4,
    id_country: 184,
    code: 'AR',
    name: 'Arkansas',
  },
  {
    id: 5,
    id_country: 184,
    code: 'CA',
    name: 'California',
  },
  {
    id: 6,
    id_country: 184,
    code: 'CO',
    name: 'Colorado',
  },
  {
    id: 7,
    id_country: 184,
    code: 'CT',
    name: 'Connecticut',
  },
  {
    id: 8,
    id_country: 184,
    code: 'DE',
    name: 'Delaware',
  },
  {
    id: 9,
    id_country: 184,
    code: 'FL',
    name: 'Florida',
  },
  {
    id: 10,
    id_country: 184,
    code: 'GA',
    name: 'Georgia',
  },
  {
    id: 11,
    id_country: 184,
    code: 'HI',
    name: 'Hawaii',
  },
  {
    id: 12,
    id_country: 184,
    code: 'ID',
    name: 'Idaho',
  },
  {
    id: 13,
    id_country: 184,
    code: 'IL',
    name: 'Illinois',
  },
  {
    id: 14,
    id_country: 184,
    code: 'IN',
    name: 'Indiana',
  },
  {
    id: 15,
    id_country: 184,
    code: 'IA',
    name: 'Iowa',
  },
  {
    id: 16,
    id_country: 184,
    code: 'KS',
    name: 'Kansas',
  },
  {
    id: 17,
    id_country: 184,
    code: 'KY',
    name: 'Kentucky',
  },
  {
    id: 18,
    id_country: 184,
    code: 'LA',
    name: 'Louisiana',
  },
  {
    id: 19,
    id_country: 184,
    code: 'ME',
    name: 'Maine',
  },
  {
    id: 20,
    id_country: 184,
    code: 'MD',
    name: 'Maryland',
  },
  {
    id: 21,
    id_country: 184,
    code: 'MA',
    name: 'Massachusetts',
  },
  {
    id: 22,
    id_country: 184,
    code: 'MI',
    name: 'Michigan',
  },
  {
    id: 23,
    id_country: 184,
    code: 'MN',
    name: 'Minnesota',
  },
  {
    id: 24,
    id_country: 184,
    code: 'MS',
    name: 'Mississippi',
  },
  {
    id: 25,
    id_country: 184,
    code: 'MO',
    name: 'Missouri',
  },
  {
    id: 26,
    id_country: 184,
    code: 'MT',
    name: 'Montana',
  },
  {
    id: 27,
    id_country: 184,
    code: 'NE',
    name: 'Nebraska',
  },
  {
    id: 28,
    id_country: 184,
    code: 'NV',
    name: 'Nevada',
  },
  {
    id: 29,
    id_country: 184,
    code: 'NH',
    name: 'New Hampshire',
  },
  {
    id: 30,
    id_country: 184,
    code: 'NJ',
    name: 'New Jersey',
  },
  {
    id: 31,
    id_country: 184,
    code: 'NM',
    name: 'New Mexico',
  },
  {
    id: 32,
    id_country: 184,
    code: 'NY',
    name: 'New York',
  },
  {
    id: 33,
    id_country: 184,
    code: 'NC',
    name: 'North Carolina',
  },
  {
    id: 34,
    id_country: 184,
    code: 'ND',
    name: 'North Dakota',
  },
  {
    id: 35,
    id_country: 184,
    code: 'OH',
    name: 'Ohio',
  },
  {
    id: 36,
    id_country: 184,
    code: 'OK',
    name: 'Oklahoma',
  },
  {
    id: 37,
    id_country: 184,
    code: 'OR',
    name: 'Oregon',
  },
  {
    id: 38,
    id_country: 184,
    code: 'PA',
    name: 'Pennsylvania',
  },
  {
    id: 39,
    id_country: 184,
    code: 'RI',
    name: 'Rhode Island',
  },
  {
    id: 40,
    id_country: 184,
    code: 'SC',
    name: 'South Carolina',
  },
  {
    id: 41,
    id_country: 184,
    code: 'SD',
    name: 'South Dakota',
  },
  {
    id: 42,
    id_country: 184,
    code: 'TN',
    name: 'Tennessee',
  },
  {
    id: 43,
    id_country: 184,
    code: 'TX',
    name: 'Texas',
  },
  {
    id: 44,
    id_country: 184,
    code: 'UT',
    name: 'Utah',
  },
  {
    id: 45,
    id_country: 184,
    code: 'VT',
    name: 'Vermont',
  },
  {
    id: 46,
    id_country: 184,
    code: 'VA',
    name: 'Virginia',
  },
  {
    id: 47,
    id_country: 184,
    code: 'WA',
    name: 'Washington',
  },
  {
    id: 48,
    id_country: 184,
    code: 'WV',
    name: 'West Virginia',
  },
  {
    id: 49,
    id_country: 184,
    code: 'WI',
    name: 'Wisconsin',
  },
  {
    id: 50,
    id_country: 184,
    code: 'WY',
    name: 'Wyoming',
  },
  {
    id: 51,
    id_country: 141,
    code: 'AB',
    name: 'Alba',
  },
  {
    id: 52,
    id_country: 141,
    code: 'AR',
    name: 'Arad',
  },
  {
    id: 53,
    id_country: 141,
    code: 'AG',
    name: 'Arges',
  },
  {
    id: 54,
    id_country: 141,
    code: 'BC',
    name: 'Bacau',
  },
  {
    id: 55,
    id_country: 141,
    code: 'BH',
    name: 'Bihor',
  },
  {
    id: 56,
    id_country: 141,
    code: 'BN',
    name: 'Bistrita-Nasaud',
  },
  {
    id: 57,
    id_country: 141,
    code: 'BT',
    name: 'Botosani',
  },
  {
    id: 58,
    id_country: 141,
    code: 'BR',
    name: 'Braila',
  },
  {
    id: 59,
    id_country: 141,
    code: 'BV',
    name: 'Brasov',
  },
  {
    id: 60,
    id_country: 141,
    code: 'B1',
    name: 'Bucuresti Sector 1',
  },
  {
    id: 61,
    id_country: 141,
    code: 'B2',
    name: 'Bucuresti Sector 2',
  },
  {
    id: 62,
    id_country: 141,
    code: 'B3',
    name: 'Bucuresti Sector 3',
  },
  {
    id: 63,
    id_country: 141,
    code: 'B4',
    name: 'Bucuresti Sector 4',
  },
  {
    id: 64,
    id_country: 141,
    code: 'B5',
    name: 'Bucuresti Sector 5',
  },
  {
    id: 65,
    id_country: 141,
    code: 'B6',
    name: 'Bucuresti Sector 6',
  },
  {
    id: 66,
    id_country: 141,
    code: 'BZ',
    name: 'Buzau',
  },
  {
    id: 67,
    id_country: 141,
    code: 'CL',
    name: 'Calarasi',
  },
  {
    id: 68,
    id_country: 141,
    code: 'CS',
    name: 'Caras-Severin',
  },
  {
    id: 69,
    id_country: 141,
    code: 'CJ',
    name: 'Cluj',
  },
  {
    id: 70,
    id_country: 141,
    code: 'CT',
    name: 'Constanta',
  },
  {
    id: 71,
    id_country: 141,
    code: 'CV',
    name: 'Covasna',
  },
  {
    id: 72,
    id_country: 141,
    code: 'DB',
    name: 'Dambovita',
  },
  {
    id: 73,
    id_country: 141,
    code: 'DJ',
    name: 'Dolj',
  },
  {
    id: 74,
    id_country: 141,
    code: 'GL',
    name: 'Galati',
  },
  {
    id: 75,
    id_country: 141,
    code: 'GR',
    name: 'Giurgiu',
  },
  {
    id: 76,
    id_country: 141,
    code: 'GJ',
    name: 'Gorj',
  },
  {
    id: 77,
    id_country: 141,
    code: 'HR',
    name: 'Harghita',
  },
  {
    id: 78,
    id_country: 141,
    code: 'HD',
    name: 'Hunedoara',
  },
  {
    id: 79,
    id_country: 141,
    code: 'IL',
    name: 'Ialomita',
  },
  {
    id: 80,
    id_country: 141,
    code: 'IS',
    name: 'Iasi',
  },
  {
    id: 81,
    id_country: 141,
    code: 'IF',
    name: 'Ilfov',
  },
  {
    id: 82,
    id_country: 141,
    code: 'MM',
    name: 'Maramures',
  },
  {
    id: 83,
    id_country: 141,
    code: 'MH',
    name: 'Mehedinti',
  },
  {
    id: 84,
    id_country: 141,
    code: 'MS',
    name: 'Mures',
  },
  {
    id: 85,
    id_country: 141,
    code: 'NT',
    name: 'Neamt',
  },
  {
    id: 86,
    id_country: 141,
    code: 'OT',
    name: 'Olt',
  },
  {
    id: 87,
    id_country: 141,
    code: 'PH',
    name: 'Prahova',
  },
  {
    id: 88,
    id_country: 141,
    code: 'SJ',
    name: 'Salaj',
  },
  {
    id: 89,
    id_country: 141,
    code: 'SM',
    name: 'Satu Mare',
  },
  {
    id: 90,
    id_country: 141,
    code: 'SB',
    name: 'Sibiu',
  },
  {
    id: 91,
    id_country: 141,
    code: 'SV',
    name: 'Suceava',
  },
  {
    id: 92,
    id_country: 141,
    code: 'TR',
    name: 'Teleorman',
  },
  {
    id: 93,
    id_country: 141,
    code: 'TM',
    name: 'Timis',
  },
  {
    id: 94,
    id_country: 141,
    code: 'TL',
    name: 'Tulcea',
  },
  {
    id: 95,
    id_country: 141,
    code: 'VL',
    name: 'Valcea',
  },
  {
    id: 96,
    id_country: 141,
    code: 'VS',
    name: 'Vaslui',
  },
  {
    id: 97,
    id_country: 141,
    code: 'VN',
    name: 'Vrancea',
  },
];

export default states;
